<template>
<v-container>
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-card-text>
          <v-container>
            <h2 class="mb-4">Edit Item</h2>
            <form @submit.prevent="editHandout()">

              <v-text-field
                class="txt"
                name="title"
                label="Title"
                id="title"
                type="text"
                v-model="title"
                required>
              </v-text-field>

              <v-text-field
                class="mb-0 txt"
                name="description"
                label="Description"
                id="description"
                type="text"
                v-model="description">
              </v-text-field>

              <span class="archived">
                Uploaded: {{item.uploaded}}
                <v-checkbox
                  :label="this.getStatus()"
                  v-model="archived"
                  class="mb-0 mt-0 pa-0 ml-3"
                ></v-checkbox>
              </span>

              <v-select
                label="Viewable By"
                id="vb"
                class="sel"
                menu-props="auto"
                v-model="vb"
                placeholder="Select from list"
                :items="students"
                item-text="name"
                item-value="userId"
                required
                dense
              ></v-select>

              <v-layout row class="mt-4">
                <v-flex xs12>
                  <v-btn small type="submit" class="secondary mr-0" :disabled="!formIsValid" >Submit</v-btn>
                  <v-btn small @click="deleteItem" class="secondary mr-0">Delete</v-btn>
                  <v-btn small @click="$router.go(-1)" >Cancel</v-btn>
                </v-flex>
              </v-layout>
            </form>

          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
export default {
  mounted() {
    this.title = this.item.title
    this.archived = this.item.archived
    this.vb = this.item.viewableBy
    this.item.description ? this.description = this.item.description : this.description = ""
  },
  props: ['item'],
  data() {
    return {
      title: "",
      description: "",
      vb: "",
      archived: false
    }
  },
  computed: {
    students() {
      return this.$store.getters.getActiveStudents;
    },
    formIsValid() {
      return this.title !== "" && this.vbs !== ""
    }
  },
  methods: {
    getStatus() {
      let str = ""
      if (this.archived === false) {
        str = "Archive"
      } else {
        str = "Archived"
      }
      return str
    },
    editHandout() {
      const editedItem = {
        title: this.title,
        description: this.description,
        downloadURL: this.item.downloadURL,
        type: this.item.type,
        archived: this.archived,
        viewableBy: this.vb,
        docId: this.item.docId
      }
      this.$store.dispatch("editItem", editedItem)
    },
    deleteItem() {
      const itemToDelete = {
        type: this.item.type,
        docId: this.item.docId,
        name: this.item.name
      }
      if (confirm("Are you sure you want to delete this item?")) {
        this.$store.dispatch("deleteItem", itemToDelete)
      }
    }
  }
}
</script>

<style scoped>
.container {
  padding: 0px;
}

.txt {
  font-size: 1rem;
}

p {
  padding: 0;
}

.sel {
  font-size: 1rem;
  margin-bottom: 25px;
  margin-top: 0px;
}

.archived {
  display: inline-flex;
  margin-top: 10px;
  /* align-items: baseline; */
}
</style>